export enum MfaMethod {
  SMS = 'SMS_MFA',
  TOTP = 'SOFTWARE_TOKEN_MFA',
  None = 'NONE',
}
